import Button from '../../components/form-control/Button';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import { getStaffById, submitStaffPermissionsByStaffId } from '../../api/requests';
import { ACCESS_RIGHTS } from '../../resources/enums';
import useUserAccount from '../../hooks/userAccountHook';
import RoleList from '../shared/settings/RolesAndPermisions/RoleList';
import { useQuery } from '@tanstack/react-query';
import { CircleCheck } from 'lucide-react';
import { showToast } from '../../utils/miscFunctions';
import { IRequestResponse } from '../../resources/interfaces';

export interface ISetPermission {
  staffID: string;
  accessRight: ACCESS_RIGHTS;
  staffCompanyType: string;
}


const SetPermissionsModal = ({ onProceed, onClose, staffID, staffCompanyType }: { onProceed: () => void; onClose: () => void; staffID: string, staffCompanyType: string; }) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { user } = useUserAccount();
  const [staffInfo, setStaffInfo] = useState<any>()
  const [staffPerms, setStaffPerms] = useState([])
  const [listOfSelectedPermissions, setListOfSelectedPermissions] = useState<string[]>([])



  const getStaffInfoById = async () => {
    await getStaffById(staffID)
      .then((response: any) => {
        setStaffInfo(response)
        setStaffPerms(response.permissions)

      })
      .catch((error: Error) => {
        console.log("error", error)
      })
  }


  useQuery({ queryKey: ['getStaffInfoById'], queryFn: getStaffInfoById })
  const submitHandler = async (values: any) => {
    setSubmitting(true);

    if (staffID) {
      await submitStaffPermissionsByStaffId(Number(staffID), { permissions: listOfSelectedPermissions })
        .then((response: any) => {
          showToast.success(response?.message ?? 'Staff permission udpated successfully')
        })
        .catch((error: IRequestResponse) => {
          showToast.error(error.description ?? 'Something went wrong! Unable to update staff permissions')
        })
        .finally(() => { setSubmitting(false); onProceed(); })
    }

  };



  return (
    <div className="bg-white p-5 rounded-xl grid grid-cols-2 dark:bg-darkBg dark:text-darkBg-mainText">

      {<div className='flex flex-col gap-3 p-[1rem]'>
        <div className='flex rounded-full border broder-2 p-2'>Name: <span className='font-semibold ml-3'>{staffInfo?.fullName ?? '-'}</span></div>
        <div className='flex rounded-full border broder-2 p-2'>Email: <span className='font-semibold ml-3'>{staffInfo?.email ?? '-'}</span></div>
        <div className='flex rounded-full border broder-2 p-2'>Company: <span className='font-semibold ml-3'>{staffInfo?.company?.name ?? '-'}</span></div>
        <h3 className='font-semibold'>{`Staff's Permissions`}:</h3>
        {staffInfo?.permissions && <div className={`flex border broder-2 p-2 h-[350px] ${staffInfo?.permissions ? 'overflow-y-scroll' : ' overflow-y-hidden'}`}>
          <ul>
            {staffInfo?.permissions?.map((permission: any) => { return <li key={permission.key} className='flex items-center '><CircleCheck className='h-4 w-4 mr-3 text-green-600' />{permission.description}</li> })}

          </ul>

        </div>}
      </div>}
      <div className="p-[1rem] w-full">
        <Formik
          initialValues={{
            permission: ''
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={Yup.object({
            //permission: Yup.string().required('Permission is required.')
          })}
          onSubmit={(values) => {
            submitHandler(values);

          }}>
          {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
            <form className="space-y-5" onSubmit={handleSubmit}>
              <h3 className='text-xl font-bold'>Available Permissions</h3>
              {staffPerms && <div className={`h-[550px] ${staffPerms ? 'overflow-y-scroll' : 'overflow-y-hidden'} space-y-4`}>

                <RoleList isByCompanyType={true} userCompanyType={staffCompanyType}
                  staffPermissions={staffPerms} setPermissionsList={(list: string[]) => { setListOfSelectedPermissions(list) }}

                />
              </div>}

              <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                //   loading={submitting}
                //   disabled={submitting}
                />
                <Button
                  type="submit"
                  label="Submit"
                  bgColor='primary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>

            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SetPermissionsModal;
